import { SELECT, SIZE_WIDTH, SIZE_WIDTH_SLIDING } from '../../utils';
import { findClosest, getCmsSelectIndex } from '../../views/viewUtils';
/**
 * Set the width to an allowed value in case of sliding doors.
 *
 * @param formState Redux formState
 * @param cmsState Redux cmsState
 * @param selectOption Function to select an option
 */
export const handleSlidingDoorsWidth = (formState, cmsState, selectOption) => {
    const exclude = [175, 225, 250, 275, 325, 375, 425];
    const selectState = formState.selectState[SIZE_WIDTH];
    const options = cmsState.form.find(f => f.id === SIZE_WIDTH_SLIDING)?.options.map(o => Number(o.value)) ?? [];
    if (exclude.includes(Number(formState.size_width)) || Number(formState.size_width) < 150) {
        const closest = findClosest(options, Number(selectState?.value));
        selectOption(SIZE_WIDTH, closest.toString(), SELECT, getCmsSelectIndex(cmsState.form, SIZE_WIDTH, closest));
    }
};
//# sourceMappingURL=utils.js.map